<template>
  <v-dialog v-model="value" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="!isNew ? item.email : ''">
      <v-form ref="form" v-model="validForm" autocomplete="off" role="presentation">
        <v-container grid-list-md>
          <v-layout wrap>



             <v-flex xs12 sm12 md12>
               <v-autocomplete
                md4
                clearable
                :search-input.sync="companySearchString"
                v-model="item.company_id"
                :items="companies"
                color="green"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Company"
                placeholder="Choose from Companies..."
                prepend-icon="mdi-database-search"
                :loading="loadingCompanies"
                :rules="validators.company_has_protocol.company"
              >
                <template slot="item" slot-scope="{ item }" >
                  <v-list-tile-content>
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                    </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>


            <v-flex xs12 sm6 md6>
              <v-select
                clearable
                md4
                v-model="item.protocol_id"
                :items="protocols"
                label="Protocol"
                :rules="validators.company_has_protocol.protocol"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-flex>



            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Protocol company code"
                v-model="item.protocol_company_code"
              ></v-text-field>
            </v-flex>


         
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!validForm"
          @click="save()"
          v-if="$can('upsert', 'company_protocol')"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/company_has_protocol";
import { getList as getCompanies } from "@/api/company";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  props: {
    item : {},
    value: false
  },
  data() {
    return {
      validForm: true,
      validators,
      loadingCompanies: false,
      companySearchString: '',
      companies: []
    };
  },
  mounted() {
    if (!this.isNew) {
      this.companies.push(this.item.company);
    }
  },
  watch: {
    value() {
      if (this.isNew) {
        this.$refs.form.reset();
      } else {
         this.companies.push(this.item.company);
      }
    },
    companySearchString(val, oldVal) {
        if (!val) {
          this.companies = [];
          return;
        }
        this.loadingCompanies = true
        getCompanies({'name': val + '%'}, {rowsPerPage: null}).then((data) => {
          this.companies = data.data;
          this.loadingCompanies = false;
        })
    },
  },
  computed: {
    isNew() {
      return !this.item.isNew ? false : true;
    },
    title() {
      return this.isNew ? "New Company Protocol" : "Edit Company Protocol" ;
    },
    protocols() {
      if (!this.$store.getters.protocols.length) {
         this.$store.dispatch("app/loadProtocols");
      }
      return this.$store.getters.protocols;
    },
  },
  methods: {
    close() {
       this.$emit('input', false)
    },
    // selectedCompany(v) {
    //   this.companies.forEach( el => {
    //     if (el.id == v) {
    //       this.item.company_id = el.id;
    //     }
    //   })
    // },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          const message = this.isNew ? "Company protocol created correctly" : 
            "Company protocol updated correctly";
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$root.$emit('updateCompanyProtocols', newItem);
        })
        .catch(e => {
          const mex = this.isNew ? "An Error occurred during the Company protocol create. " : 
            "An Error occurred during the Company protocol update. ";
          this.$store.dispatch("app/openSnackbar", {
            message: mex + e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
